<app-availability-navbar></app-availability-navbar>
<div class="main-view">
  <router-outlet />
</div>
